import { FC } from "react";

export const IconCog: FC = () => (
  <svg viewBox="22 21 56 58">
    <path
      fillRule="evenodd"
      d="M35.774 65.454l-6.41 3.481a27.97 27.97 0 0 1-6.074-10.534l6.218-3.81a20.978 20.978 0 0 1-.005-9.185l-6.218-3.81A28.1 28.1 0 0 1 25.75 36a28.1 28.1 0 0 1 3.613-4.934l6.41 3.48a20.978 20.978 0 0 1 7.956-4.588l.19-7.29a27.97 27.97 0 0 1 12.16-.008l.19 7.293a21.073 21.073 0 0 1 4.23 1.86 21.073 21.073 0 0 1 3.726 2.733l6.41-3.481a27.97 27.97 0 0 1 6.074 10.534l-6.218 3.81c.67 2.987.692 6.124.005 9.185l6.218 3.81A28.1 28.1 0 0 1 74.25 64a28.1 28.1 0 0 1-3.613 4.934l-6.41-3.48a20.978 20.978 0 0 1-7.956 4.588l-.19 7.29a27.97 27.97 0 0 1-12.16.008l-.19-7.293a21.073 21.073 0 0 1-4.23-1.86 21.073 21.073 0 0 1-3.726-2.733zM44 60.392C49.74 63.706 57.079 61.74 60.392 56 63.706 50.26 61.74 42.921 56 39.608 50.26 36.294 42.921 38.26 39.608 44 36.294 49.74 38.26 57.079 44 60.392z"
    />
  </svg>
);
